import Trade from '../MobileView/pages/Trade';
import History from '../MobileView/pages/History';
import Setting from '../MobileView/pages/Setting';
import Chart from '../MobileView/pages/Chart.jsx';
import Quotes from '../MobileView/pages/Quotes.jsx';
import MainAuth from '../pages/auth/Login/MainAuth.jsx';
import { HiHome } from "react-icons/hi2";
import { HiOutlineHome } from "react-icons/hi2";
import { HiOutlinePresentationChartLine } from "react-icons/hi2";
import { HiPresentationChartLine } from "react-icons/hi2";
import { BsBarChart } from "react-icons/bs";
import { BsBarChartFill } from "react-icons/bs";
import { LuRefreshCcw } from "react-icons/lu";
import { RiRefreshFill } from "react-icons/ri";
import { AiOutlineSetting } from "react-icons/ai";
import { AiFillSetting } from "react-icons/ai";
import Account from '../MobileView/pages/Account.jsx';
import Report from '../MobileView/pages/Report.jsx';
import Journal from '../MobileView/pages/Journals.jsx';
import MailComponent from '../MobileView/pages/MailComponent.jsx';
import NewsComponent from '../MobileView/pages/NewsComponent.jsx'
import Alert from '../MobileView/pages/Alert.jsx'
import AboutUs from '../MobileView/pages/About.jsx'
import Users from '../MobileView/pages/Users.jsx'

export const mobileRoutes = [
  { path: "/quote", title: "Home", component: Quotes, activeIcon: <HiHome style={{ fontSize: 21 }} />, icon: <HiOutlineHome style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "*", type: "private", component: Quotes, title: "Quote", isMobile: true, isMenu: false },
  { path: "/chart", title: "Chart", component: Chart, activeIcon: <HiPresentationChartLine style={{ fontSize: 21 }} />, icon: <HiOutlinePresentationChartLine style={{ fontSize: 24 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/trade", title: "Trade", component: Trade, activeIcon: <BsBarChartFill style={{ fontSize: 21 }} />, icon: <BsBarChart style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/history", title: "History", component: History, activeIcon: <RiRefreshFill style={{ fontSize: 21 }} />, icon: <LuRefreshCcw style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/settings", title: "Settings", component: Setting, activeIcon: <AiFillSetting style={{ fontSize: 21 }} />, icon: <AiOutlineSetting style={{ fontSize: 23 }} />, type: "private", isMobile: true, isMenu: false },
  { path: "/", type: "auth", component: MainAuth, title: "Login", isMobile: true, isMenu: false },
  { path: "/user", title: "User", component: Users, type: "private", isMobile: true, isMenu: false },
  { path: "/account", title: "Account", component: Account, type: "private", isMobile: true, isMenu: false },
  { path: "/reports", title: "Reports", component: Report, type: "private", isMobile: true, isMenu: false },
  { path: "/journal", title: "Journal", component: Journal, type: "private", isMobile: true, isMenu: false },
  { path: "/mails", title: "Mails", component: MailComponent, type: "private", isMobile: true, isMenu: false },
  { path: "/news", title: "News", component: NewsComponent, type: "private", isMobile: true, isMenu: false },
  { path: "/alerts", title: "Alerts", component: Alert, type: "private", isMobile: true, isMenu: false },
  { path: "/about", title: "About Us", component: AboutUs, type: "private", isMobile: true, isMenu: false },
];
